import { useRef, useEffect } from 'react';
import { useAnimation } from 'framer-motion';
import { useIntersectionObserver } from 'usehooks-ts';

import { asIntersectionObserverRef } from '../../utils/hooks';
import Section from '../Sections/Section/Section';
import Paragraph from '../Paragraph/Paragraph';
import SectionHeader2 from '../SectionHeader2/SectionHeader2';
import FadeIn from '../FadeIn/FadeIn';

import styles from './AboutSection.module.css';

interface Props {
  title: string;
  description: string;
}

export default function AboutSection ({ title, description }: Props) {
  const ref = useRef<HTMLElement>(null);
  const entry = useIntersectionObserver(asIntersectionObserverRef(ref), {
    root: null,
    rootMargin: '20px',
    threshold: 0.5,
    freezeOnceVisible: true
  })
  const isVisible = !!entry?.isIntersecting;
  const controls = useAnimation();

  useEffect(() => {
    controls.start('show');
  }, [isVisible, controls]);

  return (
    <Section ref={ref} className={styles.section}>
      <FadeIn
        yOffset={10}
        duration={1}
        controls={controls}
      >
        <SectionHeader2 text='ABOUT ME' />
      </FadeIn>
      <FadeIn
        yOffset={10}
        duration={0.6}
        delayOrder={2}
        controls={controls}
      >
        <Paragraph
          fontSize={20}
          marginBottom={20}
          maxWidth={700}
          texts={title}
          textAlign="center"
          fontVariant="alt"
        />
        <Paragraph 
          texts={description}
        />
      </FadeIn>
    </Section>
  )
}
